import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import WorkspaceDetailView from '../WorkspaceDetailView';
import CompareView from '../CompareView';
import classNames from 'classnames';

function WorkspaceDetailModal({
  dispatch,
  umoID,
  cardURL,
  toggleWorkspaceDetailView,
  retrieveUMOs,
  username,
  modalWorkspaceID,
}) {
  return umoID ? (
    <Modal
      show
      onHide={() => toggleWorkspaceDetailView(false)}
      dialogClassName={classNames(
        'workspace-detail-modal',
        typeof umoID === 'object' && 'workspace-detail-modal-compare-view'
      )}
    >
      {typeof umoID === 'object' ? (
        <CompareView
          selectedIDs={umoID}
          toggleWorkspaceDetailView={toggleWorkspaceDetailView}
          dispatch={dispatch}
          retrieveUMOs={retrieveUMOs}
        />
      ) : (
        <WorkspaceDetailView
          umoID={umoID}
          toggleWorkspaceDetailView={toggleWorkspaceDetailView}
          dispatch={dispatch}
          retrieveUMOs={retrieveUMOs}
          username={username}
          cardURL={cardURL}
          modalWorkspaceID={modalWorkspaceID}
        />
      )}
    </Modal>
  ) : null;
}

WorkspaceDetailModal.propTypes = {
  umoID: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
  toggleWorkspaceDetailView: PropTypes.func,
  dispatch: PropTypes.func,
  retrieveUMOs: PropTypes.func,
  username: PropTypes.string,
  modalWorkspaceID: PropTypes.instanceOf(Object),
  cardURL: PropTypes.string,
};

export default WorkspaceDetailModal;
